export const extensionRoutes = [  {
    path: 'extensions/subscriptions',
    loadChildren: () => import('./extensions/subscriptions-extension/routes'),
  }];
